import React, { Component } from "react";
import { Row, Column } from "react-foundation";

import Logo from "components/Logo";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import ThemeButton from "./../../components/ThemeButton";
import SimpleFormField from "../../components/SimpleFormField";
import { saveForLater } from "../../actions";

class EmailUnpricedQuote extends Component {
    constructor(props) {
        super(props);
        this.state = { submitting: false };
    }
    onSubmit(values) {
        if (this.state.submitting) return;

        this.setState({ submitting: true });

        // save
        this.props.saveForLater(values, false, () => {
            this.props.history.push("Thanks");
        });
    }
    render() {
        return (
            <div style={{ position: "relative" }}>
                <Logo topLeft={true} />
                <Row className="top-padding-page">
                    <Column small={10} medium={8} large={6} centerOnSmall>
                        <h3>Save my quote</h3>
                        <p>Please fill in your email so we can send you your quote</p>
                    </Column>
                    <Column small={8} medium={6} large={4} centerOnSmall>
                        <form onSubmit={this.props.handleSubmit(this.onSubmit.bind(this))}>
                            <Row isColumn style={{ textAlign: "left" }}>
                                <Field name="email" component={SimpleFormField} autoFocus={true}>
                                    Your email:
                                </Field>
                            </Row>
                            <Row isColumn style={{ textAlign: "left" }}>
                                <p
                                    style={{
                                        fontSize: "0.7em",
                                        marginTop: 5,
                                        marginBottom: 5
                                    }}
                                >
                                    We’ll only use this information to allow your chosen approved
                                    supplier to get in touch with you, and allow you to access your
                                    quote again in the future.
                                </p>
                            </Row>
                            <Row isColumn style={{ textAlign: "left" }}>
                                <Field name="TandC" type="checkbox" component={SimpleFormField}>
                                    {"I agree with QuoteBuilder's "}
                                    <a
                                        href="http://www.doubleglazingnetwork.com/terms-conditions/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Terms and Conditions
                                    </a>
                                </Field>
                            </Row>
                            <Row isColumn style={{ textAlign: "left" }}>
                                <Field
                                    name="consentCommunication"
                                    type="checkbox"
                                    component={SimpleFormField}
                                >
                                    I agree for Quote Builder to contact me.
                                </Field>
                            </Row>
                            <Row isColumn style={{ textAlign: "left" }}>
                                <p
                                    style={{
                                        fontSize: "0.7em",
                                        marginTop: 5,
                                        marginBottom: 5
                                    }}
                                >
                                    We may wish to also contact you for marketing purposes. If you
                                    consent please choose how we can contact you below:
                                </p>
                            </Row>
                            <Row isColumn style={{ textAlign: "left" }}>
                                <Field
                                    name="consentMarketingEmails"
                                    type="checkbox"
                                    component={SimpleFormField}
                                >
                                    Email
                                </Field>
                            </Row>

                            <Row isColumn>
                                <ThemeButton
                                    className={this.state.submitting ? "button-submitting" : ""}
                                >
                                    Save
                                </ThemeButton>
                            </Row>
                        </form>
                    </Column>
                </Row>
            </div>
        );
    }
}

const validate = values => {
    let errors = {};

    if (!values.email) errors.email = "Required";
    if (!values.TandC) errors.TandC = "Required";

    return errors;
};

export default connect(
    null,
    { saveForLater }
)(
    reduxForm({
        form: "EmailUnpricedQuote",
        validate
    })(EmailUnpricedQuote)
);



// WEBPACK FOOTER //
// ./src/containers/QuoteForm/EmailUnpricedQuote.js